import DadLogo from "@/components/DadLogo";
import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, RefreshCw } from "lucide-react";
import { useCompany } from "@/context/CompanyContext";
import useHomeResource from "@/hooks/useHomeResource";
import OrganismHero from "@/components/OrganismHero";
import { HealthStatusCard, ConsciousnessCard, InformationFlow, WorkSummary } from "@/components/HomePanels";
import { healthState } from "@/lib/dadDesign";
import { StatusBadge } from "@/components/DadStatus";
import { ResourceMessage } from "@/components/DadStatus";

export default function Home() {
  const { companyId, company } = useCompany();
  const [revision, setRevision] = useState(0);
  const retry = () => setRevision(value => value + 1);
  const organs = useHomeResource("/organs", companyId, revision, "array");
  const health = useHomeResource("/health", companyId, revision);
  const actions = useHomeResource("/actions", companyId, revision, "array");
  const documents = useHomeResource("/documents", companyId, revision, "array");
  return <HomeView company={company} organs={organs} health={health} actions={actions} documents={documents} retry={retry} />;
}
export function HomeView({ company, organs, health, actions, documents, retry }) {
  const [healthTone, healthLabel] = healthState(health.data);
  return <div className="dad-home" data-testid="home-page">
    <header className="dad-hero-heading">
      <div><p className="dad-eyebrow">Organismo · <span data-testid="home-company-name">{company?.name || "Azienda attiva"}</span></p>
        <h1><span className="dad-headline-part">LA TUA AZIENDA.</span><br /><span>CONNESSA.</span><br /><span className="dad-headline-part">SOTTO CONTROLLO.</span></h1>
        <p className="dad-subheadline">Ogni funzione lavora insieme, come in un corpo umano.</p>
        <p className="dad-supporting">Il sistema collega dati, documenti, persone e decisioni<br className="hidden sm:block" /> in un unico sistema di controllo aziendale.</p>
      </div>
      <div className="dad-hero-actions"><Link to="/censimento" className="btn-ghost" data-testid="home-censimento-link">Censimento · Audit First <ArrowUpRight size={16} /></Link>
        <button type="button" className="dad-text-link" onClick={retry}><RefreshCw size={15} /> Aggiorna dati</button></div>
    </header>
    <div className="dad-home-overview" aria-label="Controllo aziendale immediato">
      <Link to="/health-status"><strong>Stato di salute</strong><StatusBadge state={health.status === "ERROR" ? "error" : health.status === "LOADING" ? "loading" : healthTone}>{health.status === "ERROR" ? "Lettura non disponibile" : health.status === "LOADING" ? "Lettura in corso" : healthLabel}</StatusBadge></Link>
      <a href="#home-dna">DNA · Regole & Configurazione</a><a href="#home-consciousness">Coscienza · Imprenditore</a>
    </div>
    <ResourceMessage resource={organs} label="Stato degli organi" onRetry={retry} />
    <OrganismHero resource={organs} />
    <div className="dad-context-panels"><HealthStatusCard resource={health} onRetry={retry} /><div id="home-consciousness"><ConsciousnessCard /></div>
      <section id="home-dna" className="dad-panel"><span className="dad-eyebrow">DNA Aziendale</span><h2>Regole & Configurazione</h2><p>Il modo unico in cui la tua azienda funziona. Regole, personalizzazioni e processi specifici.</p>
        <Link to="/dna" className="dad-text-link">Esplora il DNA <ArrowUpRight size={16} /></Link></section>
    </div>
    <WorkSummary actions={actions} documents={documents} onRetry={retry} /><Link to="/scan" className="btn-primary dad-home-scan">SCANSIONA un documento</Link><InformationFlow />
    <footer className="dad-home-footer"><DadLogo /><span>Il cervello della tua azienda.</span></footer>
  </div>;
}
